/**
 * Google Ads tag configuration.
 *
 * Both the conversion ID and the label are public values (they ship in the
 * page source), so they live here rather than in env vars. The env override
 * exists so the label can be swapped without a code change if the "WhatsApp
 * Enquiry" conversion action is ever recreated in Google Ads.
 *
 * The ₹1200 value per lead is configured on the Ads action itself, so the
 * event does not send one.
 */

export const ADS_ID = "AW-18242374630";

export const WHATSAPP_CONVERSION_LABEL =
  process.env.NEXT_PUBLIC_ADS_CONVERSION_LABEL_WHATSAPP ?? "1X1aCIek49scEOaX0vpD";

type GtagFn = (...args: unknown[]) => void;

function getGtag(): GtagFn | null {
  if (typeof window === "undefined") return null;
  const fn = (window as unknown as { gtag?: GtagFn }).gtag;
  return typeof fn === "function" ? fn : null;
}

/**
 * Report a WhatsApp enquiry to Google Ads.
 *
 * @param onDone Called once Ads confirms the hit, or after a 700ms timeout —
 *               used to delay same-tab navigation so the beacon isn't killed.
 */
export function trackWhatsAppConversion(onDone?: () => void): void {
  const gtag = getGtag();

  if (!gtag || !WHATSAPP_CONVERSION_LABEL) {
    onDone?.();
    return;
  }

  let settled = false;
  const finish = () => {
    if (settled) return;
    settled = true;
    onDone?.();
  };

  gtag("event", "conversion", {
    send_to: `${ADS_ID}/${WHATSAPP_CONVERSION_LABEL}`,
    event_callback: finish,
  });

  window.setTimeout(finish, 700);
}
